export default class AuthController {
  constructor(AuthService, $injector) {
    "ngInject";
    this.email = "";
    this.password = "";
    this.userService = AuthService;
    this.$injector = $injector;
  }

  login($event) {
    $event.preventDefault();
    var result = this.userService.login(this.email, this.password);
    if (!result) {
      this.error = "Wrong Credentials";
    } else {
      this.$injector.get('$state').go('app');
    }
    console.log('login', this);
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/common/auth/auth.controller.js
 **/